// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-picker[data-v-b654bad0]{z-index:10000000;background:#fff}.date-picker-input[data-v-b654bad0]{width:130px}.date-picker-footer[data-v-b654bad0]{width:100%;padding:10px 10px 5px 10px;border-top:1px solid #e5e5eb}.v-picker[data-v-b654bad0]{color:#36134a}.v-picker__actions[data-v-b654bad0]{width:100%!important;padding-top:0!important}", ""]);
// Exports
module.exports = exports;
